import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { QuestionnairePage } from '../questionnaire/questionnaire';
import $ from 'jquery';
import {DataProvider} from '../../providers/data';
//declare var $: Function;

@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {
  public lang: string;
  public curCountry: string;
  private didNavigate: boolean = false;

  constructor(private dataService: DataProvider,
              public navCtrl: NavController,
              public navParams: NavParams) {
    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ionViewDidLoad() {
    this.lang = navigator.language;
  }

  public animate(e: any) {
    let button = $(<Element>e.target);
    button.css({ "box-shadow": "0px 0px black", "left": "6px", "top": "6px" });
  }

  public startQuestionnaire(language: string) {
    //this.analyticsService.emitEvent('lang', `lang-` + language);
    //localStorage.setItem("es-language", language);
    //this.translate.use(language);
    //this.router.navigate(['/questionnaire']);
    if (!this.didNavigate) {
      this.navCtrl.push(QuestionnairePage);
      this.didNavigate = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts